import { render, staticRenderFns } from "./DailyFerryList.vue?vue&type=template&id=5ad8ffff"
import script from "@/controllers/custom/daily_ferry/daily-ferry-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/daily_ferry/daily-ferry-list.js?vue&type=script&lang=js&external"
import style0 from "./DailyFerryList.vue?vue&type=style&index=0&id=5ad8ffff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports